import {AxiosError} from 'axios'
import {trans} from 'laravel-vue-i18n'

const menu:HTMLElement|null = document.getElementById('aareii-menu')
const menuToggleButton:HTMLElement|null = document.getElementById('aareii-menu-toggle-button')

export const storage = (path:string):string => {
	return `${import.meta.env.VITE_APP_URL}/storage/${path}`
}

export const copyTextToClipboard = async function(text:string):Promise<void>{
	return navigator.clipboard.writeText(text)
}

export const openMenu = function():void{
	if(menu){
		localStorage.setItem('menu', 'open')
		menu.classList.add('flex')
		menu.classList.remove('hidden')
		if(menuToggleButton && menuToggleButton.children.length > 0){
			menuToggleButton.children[0].classList.add('fa-xmark')
			menuToggleButton.children[0].classList.remove('fa-bars')
		}
	}
}

export const toggleMenu = function():void{
	if(menu && menuToggleButton){
		if(menu.classList.contains('hidden')){
			openMenu()
		} else {
			closeMenu()
		}
	}
}

export const closeMenu = function():void{
	if(menu && menuToggleButton){
		localStorage.setItem('menu', 'closed')
		menu.classList.add('hidden')
		menu.classList.remove('flex')
		if(menuToggleButton.children.length > 0){
			menuToggleButton.children[0].classList.add('fa-bars')
			menuToggleButton.children[0].classList.remove('fa-xmark')
		}
	}
}

export const showModal = function(id:string):void{
	const modal:HTMLElement|null = document.getElementById(id)
	if(modal && modal.classList.contains('hidden')){
		modal.classList.add('flex')
		modal.classList.remove('hidden')
	}
}

export const closeModal = function(id:string):void{
	const modal:HTMLElement|null = document.getElementById(id)
	if(modal && modal.classList.contains('flex')){
		modal.classList.add('hidden')
		modal.classList.remove('flex')
	}
}

export const closeAllModals = function():void{
	const modals:HTMLCollectionOf<Element> = document.getElementsByClassName('modal')
	for(let i:number = 0; i < modals.length; i++){
		const modal:Element|null = modals.item(i)
		if(modal){
			modal.classList.add('hidden')
			modal.classList.remove('flex')
		}
	}
}

export const closeDropdownList = function(id:string):void{
	const dropdownList:HTMLElement|null = document.getElementById(id)
	if(dropdownList){
		dropdownList.classList.add('hidden')
		dropdownList.classList.remove('flex')
	}
}

export const closeAllDropdownLists = function(except:string|null = null):void{
	const dropdownLists:Array<Element> = Array.from(document.getElementsByClassName('dropdown-list'))
	dropdownLists.forEach((list:Element):void => {
		if(list.id !== except){
			list.classList.add('hidden')
			list.classList.remove('flex')
		}
	})
}

export const toggleDropdown = function(id:string):void{
	closeAllDropdownLists(id)
	const dropdown:HTMLElement|null = document.getElementById(id)
	if(dropdown){
		if(dropdown.classList.contains('hidden')){
			dropdown.classList.add('flex')
			dropdown.classList.remove('hidden')
		} else {
			dropdown.classList.add('hidden')
			dropdown.classList.remove('flex')
		}
	}
}

export const validateIdNumber = function(idNumber:string):string{
	return idNumber.replace(/\D/g, '')
}

export const validateTaxNumber = function(taxNumber:string):string{
	const number:string = taxNumber.replace(/\D/g, '')
	if(number.length <= 2){
		return number
	}
	const prefix:string = number.substring(0, 2)
	if(number.length === 3){
		const middle:string = number.substring(2, number.length)
		return `${prefix}-${middle}`
	}
	const middle:string = number.substring(2, number.length - 1)
	const suffix:string = number.substring(number.length - 1, number.length)
	return `${prefix}-${middle}-${suffix}`
}

/**
 * Calculate coordinate string
 * @param {number} lat latitude
 * @param {number} long longitude
 * @return {string} the coordinates in text format like "LATº {N|S}, LONGº {E|W}"
 */
export const coordinates = function(lat:number, long:number):string{
	let res:string = Math.abs(lat).toString()
	if(lat > 0){
		res += `º ${trans('general.coord.n')}`
	} else if(lat < 0){
		res += `º ${trans('general.coord.s')}`
	}
	res += `, ${Math.abs(long).toString()}`
	if(long > 0){
		res += `º ${trans('general.coord.e')}`
	} else if(long < 0){
		res += `º ${trans('general.coord.w')}`
	}
	return res
}

export const formatNumber = (n:number, c:number = 2, d:string = '.', t:string = ','):string => {
	if(!isFinite(n)){
		n = 0
	}
	const fixed:string = n.toFixed(Math.abs(c))
	const [integerPart, decimalPart]:Array<string> = fixed.split('.')
	const withThousands:string = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, t)
	return c ? `${withThousands}${d}${decimalPart}` : withThousands
}

export const loadFile = (event:Event):File|null => {
	if(event.target && event.target instanceof HTMLInputElement && event.target.files){
		return event.target.files[0]
	}
	return null
}

export const closeAlerts = ():void => {
	const messageElement:HTMLElement|null = document.getElementById('msg')
	if(messageElement){
		messageElement.innerHTML = ''
	}
}

export const showSuccess = (text:string):void => {
	const messageElement:HTMLElement|null = document.getElementById('msg')
	if(messageElement){
		messageElement.innerHTML =
			`<div class="flex flex-col gap-1 px-3 py-2 rounded-lg bg-green-200 dark:bg-green-800 border border-green-300 dark:border-green-900 text-green-800 dark:text-green-100 shadow-lg shadow-gray-400 dark:shadow-gray-700">
            <div class="flex items-center gap-2">
                <i class="fa-solid fa-check-circle"></i>
                <p class="grow font-semibold">${trans('errors.success')}</p>
                <div class="h-6 w-6 flex items-center justify-center cursor-pointer hover:bg-green-300 dark:hover:bg-green-700 rounded toast-close-button">
                    <i class="fa-solid fa-times"></i>
                </div>
            </div>
            <p>${text}</p>
        </div>`
		activateToastCloseButtons()
		startToastAutoclosingTimer()
	}
}

const activateToastCloseButtons = ():void => {
	const buttons:Array<Element> = Array.from(document.getElementsByClassName('toast-close-button'))
	buttons.forEach((button:Element):void => {
		button.addEventListener('click', closeAlerts)
	})
}

const startToastAutoclosingTimer = ():void => {
	setTimeout(() => {
		closeAlerts()
	}, 3000)
}

export const showInfo = (text:string):void => {
	const messageElement:HTMLElement|null = document.getElementById('msg')
	if(messageElement){
		messageElement.innerHTML =
			`<div class="flex flex-col gap-1 px-3 py-2 rounded-lg bg-blue-200 dark:bg-blue-800 border border-blue-300 dark:border-blue-900 text-blue-800 dark:text-blue-100 shadow-lg shadow-gray-400 dark:shadow-gray-700">
            <div class="flex items-center gap-2">
                <i class="fa-solid fa-info-circle"></i>
                <p class="grow font-semibold">${trans('errors.info')}</p>
                <div class="h-6 w-6 flex items-center justify-center cursor-pointer hover:bg-blue-300 dark:hover:bg-blue-700 rounded toast-close-button">
                    <i class="fa-solid fa-times"></i>
                </div>
            </div>
            <p>${text}</p>
        </div>`
		activateToastCloseButtons()
	}
}

export const showError = (text:string):void => {
	const messageElement:HTMLElement|null = document.getElementById('msg')
	if(messageElement){
		messageElement.innerHTML =
			`<div class="flex flex-col gap-1 px-3 py-2 rounded-lg bg-red-200 dark:bg-red-800 border border-red-300 dark:border-red-900 text-red-800 dark:text-red-100 shadow-lg shadow-gray-400 dark:shadow-gray-700">
            <div class="flex items-center gap-2">
                <i class="fa-solid fa-times-circle"></i>
                <p class="grow font-semibold">${trans('errors.error')}</p>
                <div class="h-6 w-6 flex items-center justify-center cursor-pointer hover:bg-red-300 dark:hover:bg-red-700 rounded toast-close-button">
                    <i class="fa-solid fa-times"></i>
                </div>
            </div>
            <p>${text}</p>
        </div>`
		activateToastCloseButtons()
	}
}

export const showWarning = (text:string):void => {
	const messageElement:HTMLElement|null = document.getElementById('msg')
	if(messageElement){
		messageElement.innerHTML =
			`<div class="flex flex-col gap-1 px-3 py-2 rounded-lg bg-yellow-200 dark:bg-yellow-800 border border-yellow-300 dark:border-yellow-900 text-yellow-800 dark:text-red-100 shadow-lg shadow-gray-400 dark:shadow-gray-700">
            <div class="flex items-center gap-2">
                <i class="fa-solid fa-exclamation-triangle"></i>
                <p class="grow font-semibold">${trans('errors.warning')}</p>
                <div class="h-6 w-6 flex items-center justify-center cursor-pointer hover:bg-yellow-300 dark:hover:bg-yellow-700 rounded toast-close-button">
                    <i class="fa-solid fa-times cursor-pointer"></i>
                </div>
            </div>
            <p>${text}</p>
        </div>`
		activateToastCloseButtons()
	}
}

interface LaravelErrorResponse {
	message:string,
}

export const showValidationErrors = (error:AxiosError<LaravelErrorResponse>):void => {
	closeAlerts()
	if(error.response){
		if([401, 403, 404, 405, 419, 500, 503, 504].includes(error.response.status)){
			showError(`[${error.response.status}] ${trans(`errors.http.${error.response.status}.title`)}. ${trans(`errors.http.${error.response.status}.subtitle`)}`)
		} else if(error.response.status === 422){
			showError(`[422] ${trans('errors.http.422.title')}. ${error.response.data.message}`)
		} else {
			showError(`${error.response.status}: ${error.response.data.message}`)
		}
	} else {
		showError(error.message)
	}
}

const normalizeFuzzyString = (value:string):string => {
	return value
	.toLowerCase()
	.normalize('NFD')
	.replace(/[\u0300-\u036f]/g, '')
	.replace(/[^a-z0-9\s]/g, ' ')
	.replace(/\s+/g, ' ')
	.trim()
}

const levenshteinDistance = (a:string, b:string):number => {
	const rows:number = a.length + 1
	const columns:number = b.length + 1
	const distances:Array<Array<number>> = Array.from({length: rows}, ():Array<number> => Array(columns).fill(0))
	for(let i:number = 0; i < rows; i++){
		distances[i][0] = i
	}
	for(let j:number = 0; j < columns; j++){
		distances[0][j] = j
	}
	for(let i:number = 1; i < rows; i++){
		for(let j:number = 1; j < columns; j++){
			const substitutionCost:number = a[i - 1] === b[j - 1] ? 0 : 1

			distances[i][j] = Math.min(
				distances[i - 1][j] + 1,
				distances[i][j - 1] + 1,
				distances[i - 1][j - 1] + substitutionCost,
			)
		}
	}
	return distances[a.length][b.length]
}

const fuzzySimilarity = (a:string, b:string):number => {
	if(a === b){
		return 1
	}
	const longestLength:number = Math.max(a.length, b.length)
	if(longestLength === 0){
		return 1
	}
	return 1 - (levenshteinDistance(a, b) / longestLength)
}

const includesFuzzyWords = (a:string, b:string):boolean => {
	const aWords:Array<string> = a.split(' ').filter(Boolean)
	const bWords:Array<string> = b.split(' ').filter(Boolean)
	if(aWords.length === 0 || bWords.length === 0){
		return false
	}
	return aWords.every((aWord:string):boolean => {
		return bWords.some((bWord:string):boolean => {
			return bWord.includes(aWord) || aWord.includes(bWord) || fuzzySimilarity(aWord, bWord) >= 0.8
		})
	})
}

export const fuzzyMatch = (a:string, b:string, threshold:number = 0.72):boolean => {
	const normalizedA:string = normalizeFuzzyString(a)
	const normalizedB:string = normalizeFuzzyString(b)
	if(normalizedA.length === 0 || normalizedB.length === 0){
		return normalizedA === normalizedB
	}
	if(normalizedA.includes(normalizedB) || normalizedB.includes(normalizedA)){
		return true
	}
	if(includesFuzzyWords(normalizedA, normalizedB) || includesFuzzyWords(normalizedB, normalizedA)){
		return true
	}
	return fuzzySimilarity(normalizedA, normalizedB) >= threshold
}